import React from 'react';
import { Button, Card, CardText, Grid, Cell } from 'react-md';
import HomeSplash from '../components/HomeSplash';

import FootnoteIcon from '../components/FootnoteIcon';
import FootnotesList from '../components/FootnotesList';

import heartIcon from '../svg/ic_favorite_black_24px.svg';
import nbclcLogo from '../svg/NBCLC_Logo.svg';

const IndexPage = () => {
	const footnotes = [ "I'm a footnote!" ];

	return (
		<div className="content">
			<HomeSplash />
			<Card className="md-block-centered main-content-card">
				<CardText>
					<h1>OLLIE is your Online Legal Library and Information for Entrepreneurs.</h1>
					<p>
						This site aims to guide you through the process of getting your business off the ground,
						legally, and to safely BECOME an entrepreneur. Walk through the BECOME modules&#8212;business
						modeling, entity formation, capitalization, operational relationships, managing risks, and extra
						permits and licenses&#8212;to get a sense of the kinds of situations that trigger red flags from
						a lawyer's point of view.
					</p>
					<p>
						Throughout these modules, you'll also see footnotes that offer more information. Click or tap on
						the icon to show the footnote: <FootnoteIcon footnotes={footnotes} number={1} />
					</p>
					<Grid>
						<Cell size={6}>
							<h2>Business Modeling</h2>
							<p>
								Map out your business and pivot after getting feedback. Find out early, cheaply, and
								safely if your business needs to go in a different direction.
							</p>
							<Button raised href="/business-modeling/">
								LEARN MORE
							</Button>
						</Cell>
						<Cell size={6}>
							<h2>Entity Formation</h2>
							<p>
								Learn about the legal nuances of forming an entity. Limited liability, tax treatment,
								decision-making, and capital ($$) are the main factors.
							</p>
							<Button raised href="/entity-formation/">
								LEARN MORE
							</Button>
						</Cell>
						<Cell size={6}>
							<h2>Capitalization</h2>
							<p>
								Want to exchange a piece of your startup for money? Learn about the securities
								regulations involved, and what you'll see in convertible notes/term sheets.
							</p>
							<Button raised href="/capitalization/">
								LEARN MORE
							</Button>
						</Cell>
						<Cell size={6}>
							<h2>Operational Relationships</h2>
							<p>
								Setting up your relationships with employees, independent contractors, and interns is
								difficult to get right. Learn all about the various categories here.
							</p>
							<Button raised href="/operational-relationships/">
								LEARN MORE
							</Button>
						</Cell>
						<Cell size={6}>
							<h2>Managing Risks</h2>
							<p>
								Protect yourself and your business by securing your intellectual property. Learn more
								about trademark, copyright, and trade secret law.
							</p>
							<Button raised href="/managing-risks/">
								LEARN MORE
							</Button>
						</Cell>
						<Cell size={6}>
							<h2>Extra Permits and Licenses</h2>
							<p>
								Local county and city regulations may apply to your startup. Learn more about your local
								regulations in this module.
							</p>
							<Button raised href="/extra-permits-and-licenses/">
								LEARN MORE
							</Button>
						</Cell>
						<Cell size={12}>
							<h3>Footnotes</h3>
							<FootnotesList footnotes={footnotes} />
						</Cell>
						<Cell size={2} style={{ margin: 'auto', textAlign: 'center' }}>
							<p style={{ fontSize: '16px' }}>
								Made with <img className="svg-icon" src={heartIcon} alt="heart icon" /> by:{' '}
							</p>
							<div>
								<a href="/about-us">
									<img
										className="svg-icon"
										// style={{ width: '180px' }}
										src={nbclcLogo}
										alt="New Business Community Law Clinic logo"
										style={{ width: '200px', height: '100px' }}
									/>
								</a>
							</div>
						</Cell>
					</Grid>
				</CardText>
			</Card>
		</div>
	);
};

export default IndexPage;



// WEBPACK FOOTER //
// ./src/pages/index.js